// Handle product card options dropdown

// Two taps both saw "no gift yet" on the product page and added the subscription
// gift twice. The same lock applies when adding from a product card.
let cardOptionAddInFlight = false;

function capSubscriptionGift(cartData, giftVariantId) {
  const giftLines = (cartData.items || []).filter((item) => String(item.variant_id) === String(giftVariantId));
  const total = giftLines.reduce((sum, item) => sum + item.quantity, 0);
  if (total <= 1) return Promise.resolve(cartData);

  const updates = {};
  giftLines.forEach((item, index) => {
    updates[item.key] = index === 0 ? 1 : 0;
  });

  return fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates })
  })
    .then(() => fetch(window.Shopify.routes.root + 'cart.js'))
    .then((response) => response.json());
}

function addSubscriptionGift(cartData, giftVariantId, parentItem) {
  const alreadyInCart = cartData.items?.some((item) => String(item.variant_id) === String(giftVariantId));
  if (alreadyInCart) return capSubscriptionGift(cartData, giftVariantId);

  return fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [{
        id: Number(giftVariantId),
        quantity: 1,
        parent_line_key: parentItem?.key,
        properties: {
          _subscription_gift: 'true'
        }
      }],
      sections: ['cart-drawer', 'header']
    })
  })
    .then((response) => response.json().then((giftData) => ({ ok: response.ok, giftData })))
    .then(({ ok, giftData }) => {
      if (!ok) return capSubscriptionGift(cartData, giftVariantId);
      return fetch(window.Shopify.routes.root + 'cart.js')
        .then((response) => response.json())
        .then((refreshedCart) => {
          if (giftData.sections) refreshedCart.sections = giftData.sections;
          return capSubscriptionGift(refreshedCart, giftVariantId);
        });
    });
}

document.addEventListener('click', (e) => {
  // Close button click
  if (e.target.closest('.product-card__options-dropdown-close')) {
    const closeButton = e.target.closest('.product-card__options-dropdown-close');
    const dropdownId = closeButton.dataset.dropdownId;
    const dropdown = document.getElementById(dropdownId);
    
    if (dropdown) {
      dropdown.setAttribute('hidden', '');
      const toggleButton = document.querySelector(`[data-dropdown-id="${dropdownId}"]`);
      if (toggleButton && toggleButton.classList.contains('product-card__options-toggle')) {
        toggleButton.setAttribute('aria-expanded', 'false');
      }
    }
    return;
  }
  
  // Toggle dropdown
  if (e.target.closest('.product-card__options-toggle')) {
    const button = e.target.closest('.product-card__options-toggle');
    const dropdownId = button.dataset.dropdownId;
    const dropdown = document.getElementById(dropdownId);
    
    if (dropdown) {
      const isExpanded = button.getAttribute('aria-expanded') === 'true';
      
      // Close all other dropdowns
      document.querySelectorAll('.product-card__options-dropdown:not([hidden])').forEach(dd => {
        if (dd.id !== dropdownId) {
          dd.setAttribute('hidden', '');
          const otherButton = document.querySelector(`[data-dropdown-id="${dd.id}"]`);
          if (otherButton) {
            otherButton.setAttribute('aria-expanded', 'false');
          }
        }
      });
      
      if (isExpanded) {
        dropdown.setAttribute('hidden', '');
        button.setAttribute('aria-expanded', 'false');
      } else {
        dropdown.removeAttribute('hidden');
        button.setAttribute('aria-expanded', 'true');
      }
    }
  }
  
  // Handle option click - add to cart
  if (e.target.closest('.product-card__option-item')) {
    const optionItem = e.target.closest('.product-card__option-item');
    const variantId = parseInt(optionItem.dataset.variantId, 10);
    const sellingPlanId = optionItem.dataset.sellingPlan || '';
    
    if (!variantId || isNaN(variantId)) {
      console.error('Invalid variant ID');
      return;
    }

    if (cardOptionAddInFlight) return;
    cardOptionAddInFlight = true;
    
    // Add loading state
    optionItem.classList.add('loading');
    optionItem.disabled = true;
    
    // Prepare cart data
    const cartData = {
      items: [{
        id: variantId,
        quantity: 1
      }],
      sections: ['cart-drawer', 'header']
    };
    
    // Add selling plan if it's a subscription
    if (sellingPlanId) {
      cartData.items[0].selling_plan = parseInt(sellingPlanId, 10);
    }
    
    const dropdown = optionItem.closest('.product-card__options-dropdown');
    const giftVariantId = sellingPlanId
      ? (dropdown?.dataset.subscriptionGiftVariant || window.FoxTheme?.settings?.subscriptionGiftVariantId)
      : '';

    const finish = () => {
      cardOptionAddInFlight = false;
      optionItem.classList.remove('loading');
      optionItem.disabled = false;
    };

    // Add to cart
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(cartData)
    })
    .then(response => response.json())
    .then(data => {
      if (data.status) {
        // Error
        console.error('Error adding to cart:', data.description);
        finish();
        return;
      }
      
      // Success - get updated cart, then attach the subscription gift
      // the same way the product page does.
      return fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(cartState => {
          cartState.sections = data.sections;

          if (!giftVariantId) return cartState;

          const parentItem = data.items?.find(
            (item) => String(item.variant_id ?? item.id) === String(variantId)
          );
          return addSubscriptionGift(cartState, giftVariantId, parentItem);
        })
        .then(cartState => {
          // Update cart state
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { cart: cartState }
          }));
          
          // Dispatch product added event
          document.dispatchEvent(new CustomEvent('product-ajax:added', {
            detail: { product: data }
          }));
          
          // Dispatch cart drawer refresh event
          document.dispatchEvent(new CustomEvent('cart:refresh', {
            detail: { cart: cartState }
          }));
          
          // Update cart count
          const cartCount = document.querySelector('.cart-count');
          if (cartCount) {
            cartCount.textContent = cartState.item_count;
          }
          
          // Close dropdown
          if (dropdown) {
            dropdown.setAttribute('hidden', '');
            const toggleButton = document.querySelector(`[data-dropdown-id="${dropdown.id}"]`);
            if (toggleButton) {
              toggleButton.setAttribute('aria-expanded', 'false');
            }
          }
          
          // Show cart drawer
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            cartDrawer.show(optionItem);
          }
          
          finish();
        });
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      finish();
    });
  }
});

// Close dropdown when clicking outside
document.addEventListener('click', (e) => {
  if (!e.target.closest('.product-card__actions--relative')) {
    document.querySelectorAll('.product-card__options-dropdown:not([hidden])').forEach(dropdown => {
      dropdown.setAttribute('hidden', '');
      const button = document.querySelector(`[data-dropdown-id="${dropdown.id}"]`);
      if (button) {
        button.setAttribute('aria-expanded', 'false');
      }
    });
  }
});
